import { render, staticRenderFns } from "./premiumGoodCategoryList copy.vue?vue&type=template&id=fba51fee&scoped=true"
import script from "./premiumGoodCategoryList copy.vue?vue&type=script&lang=js"
export * from "./premiumGoodCategoryList copy.vue?vue&type=script&lang=js"
import style0 from "./premiumGoodCategoryList copy.vue?vue&type=style&index=0&id=fba51fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba51fee",
  null
  
)

export default component.exports